import type { UseQueryResult } from "@tanstack/react-query"
import { useQuery } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import { retrySolarRead } from "./solar-read-retry"
import type { SolarProposalPricingDto } from "../dto/solar-proposal-pricing.dto"
import { solarProposalService } from "../services/solar-proposal.service"

/**
 * The Solar Proposal pricing read: the stored Proposal Cost and its summary.
 * Like the other section reads it loads and fails apart from the header read,
 * and reading never prices.
 */
export default function useSolarProposalPricing(
  proposalId: string | undefined,
): UseQueryResult<SolarProposalPricingDto, unknown> {
  return useQuery({
    queryKey: queryKeys.solarProposal.pricing(proposalId ?? ``),
    queryFn: () => solarProposalService.getPricing(proposalId ?? ``),
    enabled: Boolean(proposalId),
    retry: retrySolarRead,
  })
}
